import LTR from "@brand-icons/global/fullscreen-close/fullscreen-close-ltr.svg";

import { iconFactory } from "../iconFactory";

export const FullscreenCloseIcon = iconFactory("FullscreenCloseIcon", LTR);
